<script>

export default {
    name: 'InputRange',

    props : [
        'value',
        'start',
        'min',
        'max',
        'step',
        'label',
        'attr',
        'filter',
        'format',
        'callback',
        'prefix',
        'items',
        'iconMin',
        'iconMax',
    ],

    mounted(){
        this.range = this.value ? this.value : this.start;     
        this.$emit("input", this.range, this.filter, '<=');
        this.setSlider();
    },

   data: function()
    {
        return {
            range : 0,
        }
    },

    computed : {
        uniqueId()
        {
            const id = Math.floor((Math.random() * 100) + 1);
            return this.attr+`-${id}`;
        },
        quantity(){
            let count = this.items.filter((p) => {
                return p[this.filter] <= this.range;
            });
            return count.length;
        },
        disabled(){
            return this.min === this.max;
        }
    },

    methods: {
        formatRange() {
            if (this.format === 'integer') {
                return parseInt(this.range);
            } else if (this.format === 'currency') {
                return new Intl.NumberFormat('nb-NO', {
                            style: 'decimal',
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        }).format(this.range) + ' kr';
            }
        },

        setValueMax() {
            this.range = this.max;
            this.setSlider();
        },

        setValueMin() {
            this.range=this.min;
            this.setSlider();
        },

        valueChanged(event) {
            this.setSlider();
            this.$emit("input", event.target.value, this.filter, '<=');
        },

        setSlider() {
            const el = document.getElementById(this.uniqueId);
            const min = this.min;
            const max = this.max;
            const val = this.range;
            let bg = '0% 100%';

            if(min !== max){
                bg =  (val - min) * 100 / (max - min) + '% 100%'
            } 

            if(el){
                el.style.backgroundSize = bg;
            }
            
        },
    },
}
</script>

<template>
    <div class="input-range">
        <div v-if="iconMin && iconMax" class="d-flex space-between">
            <span class="input-range__icon" v-html="iconMin" @click="setValueMin" :active="range==min" :disabled="disabled"></span>
            <span class="input-range__icon" v-html="iconMax" @click="setValueMax" :active="range==max" :disabled="disabled"></span>
        </div>
        <label :for="uniqueId" class="d-none">{{ label }}</label>
        <input type="range"
               v-model="range"
               :id="uniqueId"
               :min="min"
               :max="max"
               class="form-slider"
               :step="step"
               @input="valueChanged"
               :disabled="disabled"
        />
        <div class="input-range__text">{{ prefix }} {{ formatRange(range) }} <span class="text-grey medium">({{quantity}}stk)</span></div>
    </div>
</template>